module.exports = "https://cdn.thelire.com/ins/resource/lh_login_welcome.63d3eaa88b7b329b4d3f9ccd5d6d9614.png";